<template>
  <div class="w-full h-16 bg-gray-200" v-if="loading">
    <loading />
  </div>
  <div
    class="w-full relative cursor-pointer group"
    @click="selection ? emitSelect() : showDetails()"
    v-else
  >
    <div
      class="relative w-full grid grid-cols-auto-1-auto"
      :class="{
        'min-h-12': selection,
        ' min-h-16': !selection,
      }"
      ref="activity"
    >
      <div
        class="text-white w-16 flex items-center justify-center"
        :style="{ backgroundColor: category.color }"
      >
        <icon :name="sending ? 'Loading' : category.icon" size="1.4rem" />
      </div>
      <div
        class="text-sm tracking-wider grid grid-cols-1-auto content-center border"
        :class="{ 'p-4 py-2': selection, 'p-4': !selection }"
        :style="{
          borderColor: category.color,
          color: darkColor,
        }"
      >
        <div class="font-medium">{{ activity.title }}</div>
        <div
          class="ml-2 opacity-50 group-hover:opacity-100 transition-opacity duration-150"
        >
          <wd-button transparent @input="destroyActivity">
            <icon name="Trash" size="1.3em" />
          </wd-button>
          <wd-button class="ml-4" transparent @input="editActivity">
            <icon name="Edit" size="1.3em" />
          </wd-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateMixin from "@/mixins/DateMixin";
import FormMixin from "@/mixins/FormMixin";

import { ActivityModel } from "../viewmodels/ActivityModel";
import { ActivityCategory } from "../viewmodels/ActivityCategory";

export default {
  name: "Activity",
  mixins: [DateMixin, FormMixin],
  data() {
    return {
      sending: false,
    };
  },
  props: {
    activity: {
      default: {},
      type: ActivityModel,
    },
    category: {
      default: null,
      type: ActivityCategory,
    },
    selection: {
      default: false,
      type: Boolean,
    },
  },
  components: {},
  methods: {
    destroyActivity() {
      let destroyFormOptions = {
        async: true,
        type: "activity",
        call: "destroy",
        id: this.activity.id,
        action: (response) => {
          this.popup({
            title: this.$t("activities.activity_deleted"),
            text: this.$t("activities.activity_deleted_message", {
              activity: this.activity.title,
            }),
          });
        },
      };
      this.$store.dispatch("dialog/add", {
        title: "Löschen bestätigen",
        text: `Die Aktivität \"${this.activity.title}\" wirklich löschen?`,
        submitFn: () => {
          this.submit(destroyFormOptions);
        },
      });
    },
    adjustColor(color, amount) {
      return (
        "#" +
        color
          .replace(/^#/, "")
          .replace(/../g, (color) =>
            (
              "0" +
              Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(
                16
              )
            ).substr(-2)
          )
      );
    },
    showDetails() {
      this.goTo("/activity/" + this.activity.id);
    },
    editActivity() {
      this.goTo("/edit-activity/" + this.activity.id);
    },
    emitSelect() {
      this.$emit("select", this.activity);
    },
  },
  computed: {
    lastEntry() {
      return this.$store.getters["activityentry/lastEntryForActivity"](
        this.activity.id
      );
    },
    lastDate() {
      return this.lastEntry ? this.lastEntry.created_at : false;
    },
    finished() {
      return this.lastDate ? this.isToday(this.lastDate) : false;
    },
    lightColor() {
      return this.finished && this.swipeable
        ? "#f2f2f2"
        : this.adjustColor(this.category.color, 130);
    },
    darkColor() {
      return this.finished && this.swipeable
        ? "#333333"
        : this.adjustColor(this.category.color, -150);
    },
  },
  async created() {
    this.loaded();
  },
};
</script>
